var SCM = SCM || {};

(function (ns, $) {
    var lastScrollPosY = window.scrollY || window.pageYOffset;
    var ticking = false;
    var $body;
    var $stickyMobileNav;
    var $srFilters;
    var $issueBrowseMobileNav;
    var $leftNavColumn;
    var $leftNav;
    var $toolbarWrap;
    var toolbarHeight;
    var mobileToolbarHeight;
    var $stickyElements;
    var $stickyToolbar;
    var $header;
    var $adBannerTop;
    var $adTopConfig;
    var $adRightConfig;
    var $adDelayMilliseconds;
    var $useAdTopDelay;
    var $mainPage;
    var $rightRail;
    var $rightRailAdContainer;
    var $rightRailAd;
    var $scrollHeight;
    var leftNavStickyOffset = 0;
    var $sitewideBanner;

    ns.init = function () {
        $body = $('body');
        $mainPage = $('.js-master-container');
        $leftNavColumn = $('.js-left-nav-col');
        $leftNav = $('.js-left-nav');
        $toolbarWrap = $('.js-toolbar-wrap');
        toolbarHeight = $toolbarWrap.height();
        mobileToolbarHeight = $('.js-mobile-nav').height();
        $stickyElements = $('.js-left-nav-col, .js-toolbar-wrap, .sr-filters, .js-mobile-nav');
        $stickyToolbar = $('.js-sticky-toolbar');
        $header = $('.js-master-header');
        $sitewideBanner = $('.widget-SitewideBanner');
        $adBannerTop = $('.js-ad-banner-header');
        $adDelayMilliseconds = $('#hdnAdDelaySeconds').val();
        $adTopConfig = $('#hdnAdConfigurationTop').val();
        $adRightConfig = $('#hdnAdConfigurationRightRail').val();
        $rightRail = $('#Sidebar.page-column--right');
        $rightRailAdContainer = $('#Sidebar>div:last-of-type');
        $rightRailAd = $('#Sidebar>div:last-of-type>div');
        $issueBrowseMobileNav = $('.js-issue-browse-mobile-nav');
        $stickyMobileNav = $('.js-mobile-nav-sticky');
        $srFilters = $('.sr-filters');
        
        var $leftNavStickyOffsetHiddenField = $('#hfLeftNavStickyOffset');
        if ($leftNavStickyOffsetHiddenField.length) {
            leftNavStickyOffset = parseInt($leftNavStickyOffsetHiddenField.val());
        }

        if ($adDelayMilliseconds > 0 && $adTopConfig === 'scrolldelay') {
            $useAdTopDelay = true;
            setTimeout(function () {
                $useAdTopDelay = false;
                $adBannerTop.removeClass('fixed');
                $mainPage.removeClass('master-container-sticky');
            }, $adDelayMilliseconds);
        }

        $(window).on('scroll', onScroll);
        updateStickyElements();
    };

    /**
    * Handle window scroll, and capture current scroll position Y
    */
    function onScroll() {
        lastScrollPosY = window.scrollY || window.pageYOffset;
        if ($toolbarWrap.length && $toolbarWrap.offset().top <= 0) {
            recoverToolbarStates();
        }
        requestTick();
    }

    function recoverToolbarStates() {
        var $toolbarWraps = $('.js-toolbar-wrap');
        $toolbarWraps.each(function () {
            var $parent = $(this).parent();
            if (!$parent.hasClass('js-sticky-toolbar')) {
                $toolbarWrap = $(this);
                return;
            }
        });
        $stickyToolbar = $('.js-sticky-toolbar');
        _isToolbarCloned = null;
    }

    /**
    * Request new rAF if not active
    */
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateStickyElements);
            ticking = true;
        }
    }

    function isPageArticle() { return $body.hasClass('pg_article'); }
    function isPageArticlesByGroup() { return $body.hasClass('pg_articlesbygroup'); }
    function isPageIssue() { return $body.hasClass('pg_issue'); }
    function isPageSearch() { return $body.hasClass('pg_searchresults'); }
    function isPageSelfServe() { return $body.hasClass('pg_selfserve/sspage') || $body.hasClass('pg_selfservepage'); }
    function isPageBook() { return $body.hasClass('pg_book'); }
    function isPageChapter() { return $body.hasClass('pg_chapterstandard'); }
    function isPageSiConversionCalculator() { return $body.hasClass('pg_siconversioncalculatorpage'); }

    function updateStickyElements() {
        ticking = false;
        
        updateStickyToolbar();
        updateRightRail();
        updateLeftNav();
        updateSearchStickyToolbar();

        if (isPageIssue()) {
            updateIssueLeftNav();
        }

        updateAdvertScrollDelay();
        updateAdvertGuardian();
    }

    // checking every time because google ads aren't always loaded by document.ready()
    var _hasTopAd = null;
    function hasTopAd() {
        if (!_hasTopAd) {
            _hasTopAd = $('#adBlockHeader iframe').length;
        }
        return _hasTopAd;
    }

    var _hasRightRailAd = null;
    function hasRightRailAd() {
        if (!_hasRightRailAd) {
            _hasRightRailAd = $('#Sidebar>div:last-of-type iframe').length;
        }
        return _hasRightRailAd;
    }

    function updateRightRail() {
        // Right Rail Bottom Ad Sticky
        // For layouts with Desktop size breakpoint for Right Sidebar response
        if ($adRightConfig === 'sticky' && hasRightRailAd()) {
            var adBreakScrollPosY;
            if (hasRightRailAd() && SCM.SiteJS.getViewportWidth() > 1200) {
                if (isPageArticle()) { // Article page with fixed top menu
                    $scrollHeight =
                        50 +
                        $rightRail.height() +
                        $header.height(); // +50 for main padding
                    adBreakScrollPosY =
                        $scrollHeight -
                        $rightRailAd.height() -
                        80; // account for fixed article menu, top: 80 for Ad w/ fixed menu.

                    if (lastScrollPosY >= adBreakScrollPosY) {
                        $rightRail.css('height', $rightRail.height());
                        $rightRailAdContainer.addClass('fixed');
                    } else {
                        $rightRail.css('height', 'auto');
                        $rightRailAdContainer.removeClass('fixed');
                    }
                }

                if (isPageIssue() || isPageSearch() || isPageBook() || isPageChapter()) { // Issue, Search Pages
                    $scrollHeight =
                        50 +
                        $rightRail.height() +
                        $header.height(); // +50 for main padding
                    adBreakScrollPosY = $scrollHeight - $rightRailAd.height() - 24; // top: 24 for Ad w/out fixed menu.
                    if (lastScrollPosY >= adBreakScrollPosY) { // padding, including responsive article menu
                        $rightRail.css('height', $rightRail.height());
                        $rightRailAdContainer.addClass('fixed');
                    } else {
                        $rightRail.css('height', 'auto');
                        $rightRailAdContainer.removeClass('fixed');
                    }
                }
            } else {
                $rightRailAdContainer.removeClass('fixed');
            }

            // Right Rail Bottom Ad Sticky
            // For layouts with Tablet size breakpoint for Right Sidebar response
            if (hasRightRailAd() && SCM.SiteJS.getViewportWidth() > 1023) {
                if (isPageArticlesByGroup()) {
                    // Undo CSS bottom margin for bottom Ad on articles by group.
                    $('.pg_articlesbygroup #Sidebar .widget:last-of-type').css('margin-bottom', '0');
                }
                if (isPageArticlesByGroup() || isPageSelfServe()) { // Issue, Search Pages
                    $scrollHeight =
                        50 +
                        $rightRail.height() +
                        $header.height(); // +50 for main padding
                    adBreakScrollPosY = $scrollHeight - $rightRailAdContainer.height() - 24; // top: 24 for Ad w/out fixed menu.
                    if (lastScrollPosY >= adBreakScrollPosY) { // padding, including responsive article menu
                        $rightRail.css('height', $rightRail.height());
                        $rightRailAdContainer.addClass('fixed');
                    } else {
                        $rightRail.css('height', 'auto');
                        $rightRailAdContainer.removeClass('fixed');
                    }
                }
            } else {
                $rightRailAdContainer.removeClass('fixed');
            }
        }

    }

    // Cache value
    var _isToolbarCloned = null;
    function isToolbarCloned() {
        if (_isToolbarCloned === null) {
            _isToolbarCloned = $stickyToolbar.children().length;
        }
        return _isToolbarCloned;
    }

    function cloneToolbarToStickyToolbar() {
        if (!isToolbarCloned()) {
            // Add delay to allow any dropdowns to close before cloning
            var delayInMilliseconds = 400;
            // We don't want the toolbar to keep cloning while we wait for the delay
            _isToolbarCloned = true;
            setTimeout(function () {
                var $clone = $toolbarWrap.clone(true);
                // Rename duplicated ids
                var $duplicatedSelect = $clone.find('.js-navbar-search-filter');
                $duplicatedSelect.attr('id', 'sticky-navbar-search-filter');
                var $duplicatedSelectLabel = $clone.find('.js-navbar-search-filter-label');
                $duplicatedSelectLabel.attr('for', 'sticky-navbar-search-filter');

                var $micrositeSearchTerm = $clone.find('.js-microsite-search-term');
                $micrositeSearchTerm.attr('id', 'sticky-microsite-search-term');
                var $micrositeSearchTermLabel = $clone.find('.js-microsite-search-term-label');
                $micrositeSearchTermLabel.attr('for', 'sticky-microsite-search-term');

                var $citationFormatSelect = $clone.find('.js-citation-format');
                $citationFormatSelect.attr('id', 'sticky-select-format');
                var $citationFormatLabel = $clone.find('.js-citation-format-label');
                $citationFormatLabel.attr('for', 'sticky-selectFormat');

                // Remove unneeded html
                $clone.find('.mobile-microsite-search').remove();

                // Put html in sticky toolbar
                $stickyToolbar.append($clone);
                if (typeof addthis !== 'undefined') {
                    addthis.toolbox('.js-sticky-toolbar');
                }
            }, delayInMilliseconds);
        }
    }

    function updateStickyToolbar() {
        if (SCM.SiteJS.getViewportWidth() > 1023) {
            if ($toolbarWrap.length && (isPageArticle() || isPageChapter() || isPageBook())) {
                if (lastScrollPosY >= $toolbarWrap.offset().top + toolbarHeight) {
                    cloneToolbarToStickyToolbar();
                    $stickyToolbar.addClass('stuck');
                } else {
                    $stickyToolbar.removeClass('stuck');
                }
            }
        }
        else if ($('.js-mobile-nav').length && (isPageArticle() || isPageChapter() || isPageSiConversionCalculator())) {
            if (lastScrollPosY >= $('.js-mobile-nav').offset().top + mobileToolbarHeight) {
                $stickyMobileNav.addClass('stuck');
            } else {
                $stickyMobileNav.removeClass('stuck');
            }
        }
    }

    function updateLeftNav() {

        // ViewLarge has an undefined $header, therefore if view is ViewLarge
        // we will skip this function so MathJax can execute properly
        if (SCM.SiteJS.isPageViewLarge()) {
            return;
        }

        var guardianAdHeight = 0;
        if ($adTopConfig === 'guardian' && hasTopAd()) {
            guardianAdHeight = $adBannerTop.height();
        }

        // NARN-17805 account for the site wide banner
        var headerBoundY = !$header ? 0 : $header.height() + $header.offset().top;
        var sitewideBannerHeight = !$sitewideBanner ? 0 : $sitewideBanner.height();

        if (lastScrollPosY
            && ($header || $sitewideBanner)
            && lastScrollPosY >=
                            headerBoundY
                            + sitewideBannerHeight
                            + guardianAdHeight
                            - leftNavStickyOffset) {

            if (isPageArticle() || isPageChapter() || isPageBook() || isPageSiConversionCalculator()) {
                $leftNavColumn.addClass('stuck');
                $leftNav.css('top', '55px');
            }

            // Search Results (only for tablet/mobile)
            if (isPageSearch() && SCM.SiteJS.getViewportWidth() <= 1023) {
                $srFilters.addClass('stuck');
            }

        } else {
            // remove fixed from all 'sticky' elements
            if (isPageArticle() || isPageSearch() || isPageChapter() || isPageBook() || isPageSiConversionCalculator()) {
                $leftNav.css('top', '0px');
                $stickyElements.removeClass('stuck');
            }
        }
    }

    function updateSearchStickyToolbar() {
        if (isPageSearch() && SCM.SiteJS.getViewportWidth() <= 1023) {
            if (lastScrollPosY >= $header.height() + 148 + 70) {
                // Search Results (only for tablet/mobile)
                $srFilters.addClass('stuck');
                $srFilters.next().css('margin-top', '70px');

            } else {
                // remove fixed from all 'sticky' elements
                $stickyElements.removeClass('stuck');
                $srFilters.next().css('margin-top', '0px');
            }
        }
    }

    function updateIssueLeftNav() {
        var sitewideBannerHeight = $sitewideBanner ? $sitewideBanner.height() : 0;
        var desktopHeaderAndOffsetHeight = $header.height()
            + sitewideBannerHeight
            + $header.offset().top;
        var mobileHeaderAndOffsetHeight = $header.height()
            + sitewideBannerHeight
            + $header.offset().top
            + $leftNavColumn.height() + 30;

        var $issueDropdownWrap = $('.js-issue-dropdown-wrap');

        if ($issueDropdownWrap.length) {
            var issueDropdownBottomMargin = parseInt($issueDropdownWrap.css('margin-bottom').replace('px', ''));
            desktopHeaderAndOffsetHeight = desktopHeaderAndOffsetHeight
                + $issueDropdownWrap.height()
                + issueDropdownBottomMargin * 2;
            mobileHeaderAndOffsetHeight = mobileHeaderAndOffsetHeight
                + $issueDropdownWrap.height()
                + issueDropdownBottomMargin * 2;
        }

        if (SCM.SiteJS.getViewportWidth() > 1023) {
            if (lastScrollPosY >= desktopHeaderAndOffsetHeight) {
                // Issue Results
                $leftNavColumn.addClass('stuck');
            } else if (isPageIssue()) {
                $leftNavColumn.removeClass('stuck');
            }
        }

        if (lastScrollPosY >= mobileHeaderAndOffsetHeight) {
            $issueBrowseMobileNav.addClass('stuck');
            if (SCM.SiteJS.getViewportWidth() <= 1023) {
                $issueBrowseMobileNav.parent().css('padding-top', $issueBrowseMobileNav.height() + 32 + 'px');
            }
        }
        else if (isPageIssue()) {
            $issueBrowseMobileNav.removeClass('stuck');
            if (SCM.SiteJS.getViewportWidth() <= 1023) {
                $issueBrowseMobileNav.parent().css('padding-top', '0px');
            }
        }
    }

    function updateAdvertScrollDelay() {
        if ($adTopConfig === 'scrolldelay' && $useAdTopDelay === true && hasTopAd()) {
            if (lastScrollPosY >= $header.height() - 290) {
                $adBannerTop.addClass('fixed');
                $mainPage.addClass('master-container-sticky');
            }
            else {
                $adBannerTop.removeClass('fixed');
                $mainPage.removeClass('master-container-sticky');
            }
        }
    }

    function updateAdvertGuardian() {
        if ($adTopConfig === 'guardian' && hasTopAd()) {
            if (lastScrollPosY >= $header.height() - 290 &&
                        (lastScrollPosY < 220 && lastScrollPosY !== 0)) {
                $adBannerTop.addClass('fixed');
                $adBannerTop.removeClass('guardian-scrolled');
                $mainPage.addClass('master-container-sticky');
                $('.journal-header').show();
            }
            else if (lastScrollPosY >= 220) {
                $adBannerTop.removeClass('fixed');
                $adBannerTop.addClass('guardian-scrolled');
                $mainPage.addClass('master-container-sticky');
                $('.journal-header').hide();
            }
            else {
                $adBannerTop.removeClass('fixed');
                $adBannerTop.removeClass('guardian-scrolled');
                $mainPage.removeClass('master-container-sticky');
                $('.journal-header').show();
            }
        }
    }

})(SCM.StickyElements = SCM.StickyElements || {}, jQuery);